import {
  type OfferV11,
  OfferV1OfferFlagsEnum,
} from '@redteclab/api/clients/bully'

/**
 * bestOffer flag represents the offer which is used as the "base offer" on PDP if no specific offer is specified.
 * aka default offer for marketplace products
 */
export const productAccessorGetBestOffer = ({
  offers,
}: {
  offers: OfferV11[]
}): OfferV11 | undefined => {
  return offers.find((it) => {
    return it.offerFlags?.includes(OfferV1OfferFlagsEnum.BestOffer)
  })
}
